// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"132":"92be53f1","354":"9e2826e8","418":"17215e4e"}[chunkId] + ".js";
};